import { FormattedMessage } from 'react-intl';
import { BREAKPOINT_SM_SIZE } from '@alltrails/denali/tokens';
import Button from '@alltrails/denali/components/Button';
import Picture from '@alltrails/core/components/Picture';
import Typography from '@alltrails/core/components/Typography';
import smallSrc from './gift-card-567w.avif';
import largeSrc from './gift-card-1180w.avif';
import styles from './styles.module.scss';

const MEDIA_QUERY_SMALL_DOWN = `(max-width: ${BREAKPOINT_SM_SIZE}px)`;

// Figma: https://www.figma.com/design/SLeQY3u3PIQLGina96uVji/2025-Web-Pages?node-id=6684-41710&m=dev

export default function GenericGiftingBlock() {
  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <Picture alt="" className={styles.image} sources={[{ src: smallSrc, media: MEDIA_QUERY_SMALL_DOWN }, { src: largeSrc }]} />
      </div>
      <div className={styles.content}>
        <Typography variant="heading400" className={styles.title} component="h2">
          <FormattedMessage defaultMessage="The gift that fits their nature" />
        </Typography>
        <Typography variant="paragraph200" className={styles.subText} component="p">
          <FormattedMessage defaultMessage="Whether they’re offline explorers or custom route builders, get the perfect gift for nature lovers in your life." />
        </Typography>
        <Button text={<FormattedMessage defaultMessage="Give Adventure" />} linkInfo={{ href: '/gift' }} testId="gift-pro" variant="primary" />
      </div>
    </div>
  );
}
